import * as React from "react"

import { useDecorativeSvgs } from "../../hooks/useDecorativeSvgs"

/**
 * Holds an icon a caller passes into a slot that sits beside a name, such as
 * a menu row or an alert. An unnamed `<svg>` passed directly is hidden from
 * assistive tech; a named one, or a spinner announcing a status, stays
 * exposed. An icon wrapped in another element is not reached, so the caller
 * marks that wrapper `aria-hidden`.
 */
function IconSlot({
  as: Element = "span",
  className,
  children,
}: {
  /** `div` for a slot laid out as a block, where the icon may be block content. */
  as?: "span" | "div"
  className?: string
  children: React.ReactNode
}) {
  const setRef = useDecorativeSvgs<HTMLElement>()
  // An empty slot draws nothing, so it adds no gap beside the label.
  if (children == null || typeof children === "boolean" || children === "") {
    return null
  }
  return (
    <Element ref={setRef} className={className}>
      {children}
    </Element>
  )
}

export { IconSlot }
